import ImagesIconsAuthAddFileSvg from '@/public/images/icons/auth/add_file.svg';
import ImagesIconsAuthCheckSuccessSvg from '@/public/images/icons/auth/check-success.svg';
import ImagesIconsAuthHeadingIconSvg from '@/public/images/icons/auth/heading_icon.svg';
import ImagesIconsAuthRotateSvg from '@/public/images/icons/auth/rotate.svg';
import ImagesIconsAuthSpiritoryWhiteLogoSvg from '@/public/images/icons/auth/spiritory_white_logo.svg';
import ImagesIconsAuthWarningSvg from '@/public/images/icons/auth/warning.svg';
import ImagesIconsAuthZoomSvg from '@/public/images/icons/auth/zoom.svg';

export {
  ImagesIconsAuthAddFileSvg,
  ImagesIconsAuthCheckSuccessSvg,
  ImagesIconsAuthHeadingIconSvg,
  ImagesIconsAuthRotateSvg,
  ImagesIconsAuthSpiritoryWhiteLogoSvg,
  ImagesIconsAuthWarningSvg,
  ImagesIconsAuthZoomSvg,
};
